module.exports = __webpack_public_path__ + "static/media/A28.7e87fab7.jpg";